import { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../context";
import Logo from "../components/AllVon/VonHeader/assets/logo.png";

/**
 * Minimal layout for the course video player.
 * Shows only the topbar (no sidebar) so the video component's own
 * internal fixed course-menu panel can occupy the left side freely.
 */
export default function DashboardVideoLayout({ children }) {
  const { authState: { data } } = useContext(GlobalContext);
  const user = data?.user;
  const initials = user?.firstname?.[0]?.toUpperCase() || "U";

  return (
    <div className="flex flex-col h-screen bg-white overflow-hidden">
      {/* Slim top bar — no sidebar */}
      <header className="bg-white border-b border-gray-200 h-16 px-4 md:px-6
        flex items-center justify-between flex-shrink-0 z-30">
        <Link to="/" className="flex-shrink-0">
          <img src={Logo} alt="E1X Academy" className="h-10 w-auto object-contain" />
        </Link>

        <div className="flex items-center gap-3">
          <div className="hidden sm:block text-right">
            <p className="text-sm font-medium text-gray-800 leading-tight">
              {user?.firstname} {user?.lastname}
            </p>
            <p className="text-xs text-gray-400 leading-tight">{user?.email}</p>
          </div>
          {user?.profile_img ? (
            <img
              src={user.profile_img}
              alt="avatar"
              className="w-9 h-9 rounded-full object-cover border-2 border-[#F05A19] flex-shrink-0"
            />
          ) : (
            <div className="w-9 h-9 rounded-full bg-[#F05A19] text-white flex items-center
              justify-center font-semibold text-sm flex-shrink-0">
              {initials}
            </div>
          )}
        </div>
      </header>

      {/* Full-width content — video component manages its own internal layout */}
      <main className="flex-1 overflow-hidden relative">
        {children}
      </main>
    </div>
  );
}
